import React from 'react';
import classNames from 'classnames';
import {
    TableCell,
    TableRow,
} from 'material-ui';
import TranslationsTableItemActions from './TranslationsTableItemActions';

class TranslationsTableContent extends React.Component {

    render() {
        const {
            classes,
            block,
            site,
            blockTranslation,
            handleClick,
            handleClickOpen,
            handleDisable,
            handleEnable,
        } = this.props;

        let translationStatusStyle = classNames(
            'disabledRow', {
                [classes.disabledRow]: blockTranslation && blockTranslation.is_enabled !== 1
            }
        );

        return (
            <TableRow hover={true} className={translationStatusStyle}>
                <TableCell className={classes.tableCell}>{blockTranslation !== null ? blockTranslation.id : '-'}</TableCell>
                <TableCell className={classes.tableCell}>{site.id}</TableCell>
                <TableCell className={classes.tableCell}>{site.display_name}</TableCell>
                <TableCell className={classes.tableCell}>{blockTranslation !== null ? blockTranslation.name : 'There are no translations for this website yet!'}</TableCell>
                <TableCell className={classes.tableCell}>{blockTranslation !== null ? blockTranslation.title : 'There are no translations for this website yet!'}</TableCell>
                <TranslationsTableItemActions
                    block={block}
                    classes={classes}
                    site={site}
                    blockTranslation={blockTranslation}
                    handleClick={handleClick}
                    handleClickOpen={handleClickOpen}
                    handleDisable={handleDisable}
                    handleEnable={handleEnable}
                />
            </TableRow>
        )
    }
}

export default TranslationsTableContent;


// WEBPACK FOOTER //
// ./src/containers/blocks/translations/TranslationsTableItem.jsx